import React, { memo } from "react";
import {
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import "./index.css";

const MenuProfilesItem = ({ getCount, icon, id, onClick, selected, title }) => {
  return (
    <li>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>
            {title}
            {getCount ? ` (${getCount()})` : null}
          </Tooltip>
        }
      >
        <button
          className={`mpr-rp-icon ${selected && selected() ? "active" : ""} ${id}`}
          type="button"
          onClick={onClick}>
          {icon}
          {getCount && getCount() > 0 ? <div className="mpr-rp-icon-count">{getCount()}</div> : null}
        </button>
      </OverlayTrigger>
    </li>
  );
};

export default memo(MenuProfilesItem);
